const resultConfig = {
  '宫颈微小浸润癌(鳞癌/腺癌)': {
    label: '宫颈微小浸润癌',
    subtypeField: 'binglijieguo_gjwxqra'
  },
  '宫颈浸润癌(鳞癌/腺癌)': {
    label: '宫颈浸润癌',
    subtypeField: 'binglijieguo_gjqra'
  }
}

function formatOriginalResult (result) {
  const pathologyResult = result.binglijieguo
  let otherField

  if (pathologyResult === '其他' || pathologyResult === '其他生殖系统恶性肿瘤') {
    otherField = 'binglijieguo_other'
  } else if (pathologyResult === '其他生殖系统良性疾病') {
    otherField = 'binglijieguo_other_liangxing'
  } else if (pathologyResult === '其他不详') {
    otherField = 'binglijieguo_other_buxiang'
  }

  const otherResult = otherField && result[otherField]
  if (pathologyResult === '其他不详' && otherResult) {
    return ` 其他不详(${otherResult})`
  }
  return otherResult ? `${pathologyResult}(${otherResult})` : pathologyResult
}

export function formatPathologicalCervixResult (pathologicalCervix, fertileCheck, originalResult) {
  const result = pathologicalCervix || {}
  const pathologyResult = result.binglijieguo
  const config = resultConfig[pathologyResult]
  const shouldShowSubtype = fertileCheck === 2 || fertileCheck === '2' || fertileCheck == null || fertileCheck === ''

  if (shouldShowSubtype && config) {
    const subtype = result[config.subtypeField]
    return subtype ? `${config.label}(${subtype})` : config.label
  }

  if (typeof originalResult !== 'undefined') {
    return originalResult
  }

  return formatOriginalResult(result)
}
